import { useActions } from '@root/core/hooks/useActions';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Card, Spin } from 'antd';
import { useEffect } from 'react';
import TransactionAmount from '../../components/TransactionAmount';
import ServiceInqueryTable from '../components/ServiceInqueryTable';

const Breadcrumb = [
  {
    tittle: 'Settlement  ',
    url: ''
  },
  {
    tittle: 'Service Inquiry ',
    url: ''
  }
];

const ServiceInquiryPage = () => {
  const { getTransactionInfo } = useActions();

  useEffect(() => {
    getTransactionInfo();
  }, []);
  const { amount } = useTypedSelector((state) => state.amountInfoReducer);

  const { loading } = useTypedSelector((state) => state.settlementReducer);
  return (
    <>
      <Spin spinning={loading}>
        <BreadcrumbList listBreadcrumb={Breadcrumb} />
        <div className="admin-container">
          <Card
            bordered={false}
            className="admin-card"
            style={{
              minHeight: '80vh',
              background: 'none'
            }}
          >
            <div className="billingInquiry">
              <TransactionAmount amountInfo={amount?.data} />
              <ServiceInqueryTable />
            </div>
          </Card>
        </div>
      </Spin>
    </>
  );
};

export default ServiceInquiryPage;
